module.exports = __webpack_public_path__ + "static/playerVideo-0a77e7a87b5d05e021a7871b1ac49467.png";